import _ = require("lodash");
import { EntityConfiguration, IApiInterface } from "../../configurations/configuration";
import { UploadStatus, statusIdsForClientRequestStatus } from "../../util/UIConstants";
import { ApiModel, ServiceDataModel } from "../models/Models";
import { labels } from "../../util/utils";
import Utility from "../../util/utilityFunctions";
import { ServiceUrlHelper } from "../../helpers/ServiceUrlHelper";
import { APIMiddleware } from "../../helpers/api-middleware";
import { ClientRequestService } from "../../services/clientrequest/ClientRequestService";

export class EditClientRequestService extends ClientRequestService {
  sortingOfData = (dataList) => {
    const draft = dataList
      .filter((item) => statusIdsForClientRequestStatus.draft.includes(item.clientRequestStatusID))
      .sort((x, y) => x.referenceNumber - y.referenceNumber);

    const pendingResponse = dataList
      .filter((item) => statusIdsForClientRequestStatus.pendingResponse.includes(item.clientRequestStatusID))
      .sort((x, y) => x.referenceNumber - y.referenceNumber);

    const received = dataList
      .filter((item) => statusIdsForClientRequestStatus.received.includes(item.clientRequestStatusID))
      .sort((x, y) => x.referenceNumber - y.referenceNumber);

    const accepted = dataList
      .filter((item) => statusIdsForClientRequestStatus.accepted.includes(item.clientRequestStatusID))
      .sort((x, y) => x.referenceNumber - y.referenceNumber);

    let sortedData = [...draft, ...pendingResponse, ...received, ...accepted];
    return sortedData;
  };

  async downloadDataAsync(
    engagementId: string,
    configuration: EntityConfiguration,
    inputObjectParameter,
    ldcVersioning
  ): Promise<ServiceDataModel> {
    let dataModal;

    dataModal = await super.downloadDataAsync(engagementId, configuration, inputObjectParameter, ldcVersioning);
    if (!dataModal.ErrorCode) {
      if (dataModal.response && dataModal.response?.requestsReadModel) {
        let sortedData = this.sortingOfData(dataModal.response?.requestsReadModel);
        dataModal.response.requestsReadModel = sortedData;
      }
    }

    return dataModal;
  }

  public getFormatedDescriptionToExcelFormat = (data: string): any => {
    if (data) {
      data = data.replace(/<p>/g, "");
      let description = data.replace(/<\/p>/g, "\n");
      description = Utility.getInnerTextFromRichText(description);
      // return "T1\nT3\nT45\nTEAEEE"
      return description;
    }

    return "";
  };
}
